/**
 * 404 Not Found Page
 * Displayed when a route doesn't exist
 */
import React from 'react';
import { Link } from 'react-router';
import { FileQuestion, Home, ArrowLeft } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { useTranslation } from '../../i18n';

export function NotFound() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-[#050505] p-6">
      <div className="text-center max-w-lg">
        <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-gray-100 dark:bg-white/5 mb-8">
          <FileQuestion className="w-12 h-12 text-gray-400 dark:text-gray-500" />
        </div>

        <h1 className="text-7xl font-bold text-gray-900 dark:text-white mb-4">404</h1>
        <h2 className="text-2xl font-semibold text-gray-700 dark:text-gray-300 mb-6">
          {t('errors.notFound')}
        </h2>
        <p className="text-gray-500 dark:text-gray-400 mb-10 leading-relaxed">
          {t('errors.notFoundDescription')}
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button asChild variant="outline" className="border-gray-200 dark:border-white/10">
            <Link to="/" className="flex items-center gap-2">
              <ArrowLeft className="w-4 h-4" />
              {t('errors.goBack')}
            </Link>
          </Button>
          <Button asChild className="bg-fuchsia-600 hover:bg-fuchsia-700">
            <Link to="/" className="flex items-center gap-2">
              <Home className="w-4 h-4" />
              {t('nav.dashboard')}
            </Link>
          </Button>
        </div>
      </div>
    </div>
  );
}

export default NotFound;
